<template>
  <div>
    <b-button
      id="id-reopen-convo-btn"
      type="button"
      variant="outline-info"
      class="btn btn-rounded btn-light btn-block"
      @click.prevent="reopenConversation()"
    >
      <i v-if="httpPending" class="fa fa-spinner fa-spin"></i>
      Reopen Conversation
    </b-button>
  </div>
</template>


<script>
/* eslint-disable */
import { EventBus } from "@/events/eventBus";

export default {
  name: 'ReopenConversationCTA',
  props: {
    conversationId: String
  },
  data() {
    return {
      httpPending: false,
    }
  },
  methods: {
    async reopenConversation() {
      try {
        this.httpPending = true;
        await this.$ConveyApi.conversationsApi.updateConversation({
          conversationId: this.conversationId,
          payload: { status: 'active' }
        });
        EventBus.$emit('reopened-conversation', this.conversationId);
        this.$toastr("success", "Conversation Reopened");
      } catch(err) {
        console.log('[ReopenConversationCTA:reopenConversation] ERROR: '. err);
        this.$toastr("error", 'Error Reopening Conversation. Please try again.');
      } finally {
        this.httpPending = false;
      }
    }
  }
};
</script>
